module.exports = __webpack_public_path__ + "img/yhxylogo.da5a20e4.png";